<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">B.Sc. Computer Science</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">B.Sc. Computer Science</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="computer-application ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="department-tab" data-bs-toggle="tab" data-bs-target="#department"
              type="button" role="tab" aria-controls="department" aria-selected="true">About Department</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="duration-tab" data-bs-toggle="tab" data-bs-target="#duration" type="button"
              role="tab" aria-controls="duration" aria-selected="false">Duration</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="opportunities-tab" data-bs-toggle="tab" data-bs-target="#opportunities"
              type="button" role="tab" aria-controls="opportunities" aria-selected="false">Opportunities which await
              you</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="department" role="tabpanel" aria-labelledby="department-tab">
            <div>
              <p>B.Sc. Computer Science is a 3 year undergraduate program which deals with subjects and topics related
                to computer application and services. Technological implementation of computer systems is the main
                agenda of the program. The program ranges widely from creating quality professionals and research
                fellows who are working in every sector of the world today.</p>
            </div>
          </div>
          <div class="tab-pane fade" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <ul class="list-before">
              <li>Higher secondary School Certificate (10+2) Science stream with Mathematics or its equivalent
                examination.</li>
              <li>Three Years Diploma course, after S.S.C. (10th Standard ) of Board of Technical Education conducted by
                Government of Maharashtra or its equivalent.</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="duration" role="tabpanel" aria-labelledby="duration-tab">
            <h4 class="yellow-color fw-bold">3 years/6 semesters</h4>
            <ul class="list-before mt-3">
              <li><strong>Course curriculum:-</strong> The course lays emphasis on C, C++, HTML, PHP, and Java and web
                application development. It also involves web technology, architecture of computers and knowledge
                pertaining to operating systems. Ample opportunity for practical is provided to the students in order to
                gain first-hand experience.</li>
              <li><strong>Avenues to explore after B.sc.(Computer Science):-</strong> A plethora of jobs in the Private
                and Government organization can be explored post a degree of Bachelor of Science in Computer Science.
                The degree holders can go for jobs in the educational sector as well.</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="opportunities" role="tabpanel" aria-labelledby="opportunities-tab">
            <ul class="list-before">
              <li> Student can pursue further studies in M.Sc.(Computer Science), or MCA, MCM,MBA and follow it up by
                research or take up jobs as trainee programmers with bright future ahead.</li>
              <li> Placement- avail placement in Private or Government organization with a completed B.Sc.(CS) degree.
                System Engineer, junior programmer, software tester, software developer, web developer, system
                administrator in a private enterprise after the completion of the course.</li>
            </ul>
          </div>
        </div>
        <div class="text-center">
          <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
        </div>
      </div>
    </div>
  </div>
</section>
